import React, { Component } from 'react';
import { connect } from 'react-redux';
//import cookie from 'react-cookie'
// utils + constant + restClient
import { aemHostClient, eapiClient } from '../../restClient';
import { Translations } from '../../utils';

// child component

// actions
import axios from 'axios';
import { blockUi, unBlockUi } from '../../actions/actionCreator';
import { logInUser } from '../../actions/auth';
import { setLanguageFlag, setTranslatedData } from '../layouts/actions/actionCreator';
// style
import './sitlogin.css';

class SitLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedTerms: false,
      inputInValidEmail: undefined,
      inputInValidPassword: undefined,
      staffId: '',
      errorMsg: ""
    };
  }

  componentDidMount() {
    this.props.unBlockUi()
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

  }

  handleBlur = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  validateInput = (event) => {
    const value = event.target.value;
    // basic input validation
    if (value !== "") {
      this.setInputAsValid(event.target.name);
    } else {
      this.setInputAsInValid(event.target.name, this.props.mandatoryMessage);
    }
  }

  setInputAsValid = (fieldName) => {
    if (fieldName === "email") {
      this.setState({ inputInValidEmail: false });
    }
  }

  setInputAsInValid = (fieldName, validationMsg) => {
    if (fieldName === "email") {
      this.setState({ inputInValidEmail: true, errorMsg: "Please enter the Staff Id." });
    }
  }

  onFormSubmit = async (data) => {
    const { urls = {}, options = {} } = this.props.config
    const { OPENAM_BASE_URI, STAFF_API_URL_FOR_AUTOMATION } = urls
    const authOptions = {
      url: OPENAM_BASE_URI + STAFF_API_URL_FOR_AUTOMATION,
      method: 'post',
      withCredentials: true,
      crossDomain: true,
      dataType: 'json',
      headers: {
        'X-OpenAM-Username': this.state.staffId,
        'Content-Type': 'application/json', ...options
      }
    };
    axios(authOptions)
      .then(({ data, status, headers }) => {

        if (status === 200) {
          const openAMToken = data.tokenId;
          this.onUserLogin(openAMToken)
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 401) {
          this.setState({ inputInValidEmail: true, errorMsg: "Please enter the valid Staff Id." })
        }
      })
  }

  onUserLogin = (data) => {
    var payLoad = {};
    payLoad.token = data
    eapiClient("/users/role", {
      method: 'POST',
      timeout: 30000,
      withCredentials: true,
      credentials: 'same-origin',
      data: JSON.stringify(payLoad)
    })
      .then(({ data, status, headers }) => {
        if (status === 200) {
          const token = headers["x-hsbc-e2e-trust"];
          this.props.logInUser(true, token, '', data.responseData.principal, new Date(), '/case-list');
          aemHostClient('/aemData/formData/json_en-gb')
            .then(({ data }) => {
              this.props.setTranslatedData(data)
              this.props.history.push(this.state.from || '/case-list');
            });

        }
      });
  }
  renderFormGroups() {
    let formData = {};
    const properties = {
      formData,
      editType: 'staff-login',
      pathname: this.props.history.location.pathname
    };
    const { staffId } = this.state;
    const enabled = staffId.length > 0
    return (
      <form className="login-details-form">
        <fieldset className="fldset">
          <legend>Login</legend>
          <label htmlFor="email">
            Staff Id
          </label>
          <input
            type="number"
            name="staffId"
            id="staffId"
            onChange={this.handleChange}
            value={this.state.staffId}
            onBlur={this.validateInput}
          />
          {
            this.state.inputInValidEmail
              ? (
                <div className="sit-input-error-msg-section" role="alert">
                  <span className="icon icon-circle-delete-solid"></span>
                  {this.state.errorMsg}
                </div>
              )
              : ''
          }
          <div className="form-buttons-save-section">
            <input
              type="button"
              disabled={!enabled}
              onClick={this.onFormSubmit}
              className={!enabled ? 'gls-input-btn btn-disable' : 'gls-input-btn'}
              name="supportingDoc"
              value="Login"
            />
          </div>
        </fieldset>
      </form>
    )

  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle.pageHeading : '';
    document.title = `${this.translations(pageTitle)} - ${'HSBC GLCM'}`
    return (
      <div className="gdoc-staff-login">
        <div className="gdoc-staff-login-child">
          <div className="form-container">
            <div className="form-title">
              <h2 className="form-heading">
                {
                  this.translations(pageTitle)
                }
              </h2>
            </div>
            {this.renderFormGroups()}
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    lang: state.lang,
    config: state.config
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logInUser: (...args) => {
      dispatch(logInUser(...args));
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    setLanguageFlag: flag => {
      dispatch(setLanguageFlag(flag));
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SitLogin);


// WEBPACK FOOTER //
// ./src/components/Login/SitLogin.js